import { IconArrowRight } from '@tabler/icons-react';
import React from 'react';
import style from '../../Layout/Footer/Footer.module.css';

const Form = () => {
    return (
        <div>
            <form>
                <div>
                    <input className={style.input} type="text" placeholder="Enter your name" required />
                </div>
                <div>
                    <input className={style.input} type="tel" placeholder="Enter your contact no" required />
                </div>
                <div>
                    <input className={style.input} type="email" placeholder="Enter your email " required />
                </div>
                <div>
                    <textarea className={style.input} placeholder="Message"></textarea>
                </div>
                <button type="submit" className={style.submit}>SUBMIT <IconArrowRight /></button>
            </form>
        </div>
    )
}

export default Form